module.exports = __webpack_public_path__ + "img/ring_r_0_0_1@3x.c47fc685.png";